

































































import {
  computed,
  ComputedRef,
  defineComponent,
  PropType,
  ref
} from '~/utils/nuxt3-migration'
import CMenuItem from '~/components/shared/configurable/menu/CMenuItem.vue'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { quickSearchCategories } from '~/constants/classified/quick-search'
import { ciTimes } from '~/icons/source/regular/times'
import { ciMagnifyingGlass } from '~/icons/source/thin/magnifying-glass'
import {
  CategoryId,
  QuickSearchCategories,
  QuickSearchCategory
} from '~/models/category/types'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { AccessToggleName } from '~/models/user/access-toggles'
import CAccordion from '~/components/shared/configurable/accordion/CAccordion.vue'
import { ciDeals } from '~/icons/source/thin/deals'

export default defineComponent({
  components: {
    CAccordion,
    CMenuItem
  },
  props: {
    selectedSearchbarCategory: {
      type: Number as PropType<CategoryId>,
      required: true
    }
  },
  setup(props, { emit }) {
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const userHasAccessTo = userGetters('userHasAccessTo')

    const selectedCategory = ref(props.selectedSearchbarCategory)

    const categories: ComputedRef<QuickSearchCategories> = computed(() => {
      if (!userHasAccessTo(AccessToggleName.WANTED_PARTS_ACCESS)) {
        const filteredCategories = { ...quickSearchCategories }
        delete filteredCategories['wanted-parts']
        return filteredCategories
      }
      return quickSearchCategories
    })

    function getCategoryIcon(category: QuickSearchCategory) {
      if (category.name === 'deals') {
        return ciDeals
      }

      return categoriesIconsMappings[category.id]
    }

    function closeDrawerAfterClick() {
      emit('remove-modal-classes')
    }

    return {
      ciTimes,
      ciMagnifyingGlass,
      categories,
      selectedCategory,
      getCategoryIcon,
      closeDrawerAfterClick
    }
  }
})
